import { Mode } from '@nest/common-core-frontend-react';

export const environment = {
	applicationName: 'terminal-frontend',
	env: (import.meta.env.MODE || 'development') as Mode,
	apiUrl: import.meta.env['VITE_API_URL'] || 'http://localhost:3001',
	websocketUrl: import.meta.env['VITE_WEBSOCKET_URL'] ?? 'ws://localhost:3001'
};
